export default "__VITE_ASSET__79400037__"